import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import auth from './auth';

Vue.use(VueAxios, axios);

export default {
  auth,
};



// WEBPACK FOOTER //
// ./src/api/index.js